export default __webpack_public_path__ + "static/media/help-desk-2.d8521869.png";